/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//配置与推送业务组件
const routerView = require('components/layout/router-view/router-view')
const addAppPopUp = require('appComp/page/configPush/app-pop-up/add-app-pop-up/add-app-pop-up')
const appPopUpList = require('appComp/page/configPush/app-pop-up/app-pop-up-list/app-pop-up-list')
const messagePushList = require('appComp/page/configPush/message-push/message-push-list/message-push-list')
const messagePushAdd = require('appComp/page/configPush/message-push/add-message-push/add-message-push')

const addStartAd = require('appComp/page/configPush/start-ad/add-start-ad/add-start-ad')
const startAdList = require('appComp/page/configPush/start-ad/start-ad-list/start-ad-list')

const addAppPush = require('appComp/page/configPush/app-push/add-app-push/add-app-push')
const appPushList = require('appComp/page/configPush/app-push/app-push-list/app-push-list')

const addDesktopPush = require('appComp/page/configPush/desktop-push/add-desktop-push/add-desktop-push')
const desktopPushList = require('appComp/page/configPush/desktop-push/desktop-push-list/desktop-push-list')

const chargerIconList = require('appComp/page/configPush/charger-icon/charger-icon-list')

const addHalfPageAd = require('appComp/page/configPush/half-page-ad/add-half-page-ad/add-half-page-ad')
const halfPageAdList = require('appComp/page/configPush/half-page-ad/half-page-ad-list/half-page-ad-list')

const adConfigList = require('appComp/page/configPush/ad-config/ad-config-list/ad-config-list')
const adConfigAdd = require('appComp/page/configPush/ad-config/add/add')

const addBanner = require('appComp/page/configPush/banner/add-banner/add-banner')
const bannerList = require('appComp/page/configPush/banner/banner-list/banner-list')

const addDynamicClass = require('appComp/page/configPush/dynamic-class/add-dynamic-class/add-dynamic-class')
const dynamicClassList = require('appComp/page/configPush/dynamic-class/dynamic-class-list/dynamic-class-list')

const addListTopic = require('appComp/page/configPush/list-topic/add-list-topic/add-list-topic')
const listTopicList = require('appComp/page/configPush/list-topic/list-topic-list/list-topic-list')

const brandManager = require('appComp/page/configPush/brand-manager/brand-manager-list/brand-manager-list')

module.exports = {
  component: routerView,
  subRoutes: {
    "/appPopUp": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "查看应用内弹窗",
          component: appPopUpList
        },
        "/add": {
          title: "新增应用内弹窗",
          component: addAppPopUp
        },
        "/edit/:id": {
          title: "编辑应用内弹窗",
          component: addAppPopUp
        }
      }
    },
    "/messagePush": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "系统消息推送",
          component: messagePushList
        },
        "/add": {
          title: "系统消息推送新增",
          component: messagePushAdd
        },
        "/edit/:id": {
          title: "系统消息推送查看",
          component: messagePushAdd
        }
      }
    },
    "/adConfig": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "广告配置列表",
          component: adConfigList
        },
        "/add": {
          title: "新增广告",
          component: adConfigAdd
        },
        "/edit/:id": {
          title: "编辑广告",
          component: adConfigAdd
        },
        "/detail/:id/:flag": {
          title: "广告详情",
          component: adConfigAdd
        }
      }
    },
    "/startAd": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "查看启动页广告",
          component: startAdList
        },
        "/add": {
          title: "新增启动页广告",
          component: addStartAd
        },
        "/edit/:id": {
          title: "编辑启动页广告",
          component: addStartAd
        }
      }
    },
    "/appPush": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "查看应用推送",
          component: appPushList
        },
        "/add": {
          title: "新增应用推送",
          component: addAppPush
        },
        "/edit/:id": {
          title: "编辑应用推送",
          component: addAppPush
        }
      }
    },

    "/desktopPush": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "查看桌面级推送",
          component: desktopPushList
        },
        "/add": {
          title: "新增桌面级推送",
          component: addDesktopPush
        },
        "/edit/:id": {
          title: "编辑桌面级推送",
          component: addDesktopPush
        }
      }
    },
    "/chargerIcon": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "充电点图标",
          component: chargerIconList
        }
      }
    },
    "/halfPageAd": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "查看半页广告",
          component: halfPageAdList
        },
        "/add": {
          title: "新增半页广告",
          component: addHalfPageAd
        },
        "/edit/:id": {
          title: "编辑半页广告",
          component: addHalfPageAd
        }
      }
    },
    "/banner": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "查看横幅",
          component: bannerList
        },
        "/add": {
          title: "新增横幅",
          component: addBanner
        },
        "/edit/:id": {
          title: "编辑横幅",
          component: addBanner
        }
      }
    },
    "/dynamicClass": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "查看动态分类",
          component: dynamicClassList
        },
        "/add": {
          title: "新增动态分类",
          component: addDynamicClass
        },
        "/edit/:id": {
          title: "编辑动态分类",
          component: addDynamicClass
        }
      }
    },
    "/listTopic": {
      component: routerView,
      subRoutes: {
        "/": {
          title: "查看动态列表推荐话题",
          component: listTopicList
        },
        "/add": {
          title: "新增动态列表推荐话题",
          component: addListTopic
        },
        "/edit/:id": {
          title: "编辑动态列表推荐话题",
          component: addListTopic
        }
      }
    },
    "/brandManager":{
      component:routerView,
      subRoutes:{
        "/":{
          title:"社区品牌管理",
          component:brandManager
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/router/configPush.js